import React from 'react';
import AuditLogsTable from './AuditLogsTable';

export default function AuditLogsPage() {
  return <AuditLogsTable />;
}